"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapStoreData = exports.mapPageData = exports.mapLoginData = exports.mapFormData = void 0;
var mapFormData_1 = require("./mapFormData");
Object.defineProperty(exports, "mapFormData", { enumerable: true, get: function () { return mapFormData_1.default; } });
var mapLoginData_1 = require("./mapLoginData");
Object.defineProperty(exports, "mapLoginData", { enumerable: true, get: function () { return mapLoginData_1.default; } });
var mapPageData_1 = require("./mapPageData");
Object.defineProperty(exports, "mapPageData", { enumerable: true, get: function () { return mapPageData_1.default; } });
var mapStoreData_1 = require("./mapStoreData");
Object.defineProperty(exports, "mapStoreData", { enumerable: true, get: function () { return mapStoreData_1.default; } });
